import React, { useEffect, useState } from "react";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import UserChartPage from "./components/UserChartPage";
import StatCard from "./components/ui/StatCard";
import Spinner from "./components/ui/Spinner";
import {
  UsersIcon,
  UserPlusIcon,
  BoltIcon,
  PauseCircleIcon,
  CircleStackIcon,
} from "@heroicons/react/24/outline";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const Dashboard = () => {

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token"); // If auth is needed
        const res = await fetch(`${baseUrl}/auth/dashboard`, {
          headers: {
            Authorization: `Bearer ${token}`, // Only if required
            "Content-Type": "application/json",
          },
        });

        const result = await res.json();
        if (res.ok && result.status) {
          setDashboardData(result.data);
        } else {
          setError(result.message || "Failed to fetch dashboard data");
        }
      } catch (err) {
        console.error(err);
        setError("Network error");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <div className="flex flex-col md:flex-row bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Navbar />
        <div className="p-8">
          <h3 className="text-3xl font-semibold mb-6 text-white">Welcome to Game Gems Admin</h3>

          {loading ? (
            <div className="flex justify-center py-20">
              <Spinner size="lg" />
            </div>
          ) : error ? (
            <p className="text-red-400">{error}</p>
          ) : (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-6">
                <StatCard icon={UsersIcon} label="Total Users" value={dashboardData.totalUser} />
                <StatCard icon={UserPlusIcon} label="Today Created Users" value={dashboardData.todayCreatedUser} />
                <StatCard icon={BoltIcon} label="Active Miners" value={dashboardData.totalMiningActiveCount} />
                <StatCard icon={PauseCircleIcon} label="Inactive Miners" value={dashboardData.totalMiningInactiveCount} />
                <StatCard icon={CircleStackIcon} label="Total Coin Mined" value={dashboardData.totalCoinMin.toFixed(4)} />
              </div>

              <UserChartPage />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
